/* Mobile menu drawer + collection-card colour swatches.
   Both are plain delegated listeners so they survive markup being re-rendered
   (filters, pagination) without needing to re-bind. */
(function () {
  /* ---------------- mobile menu ---------------- */
  var menu = document.querySelector('[data-cx-menu]');
  var scrim = document.querySelector('[data-cx-scrim]');
  var opener = document.querySelector('[data-cx-menu-open]');

  function setMenu(open) {
    if (!menu) return;
    // `hidden` is removed first so the open transition has something to animate.
    // The reflow below flushes that style change synchronously — rAF would be
    // wrong here because it never fires while the page is not being painted
    // (background tab, hidden preview), leaving the drawer stuck off-canvas.
    if (open) {
      menu.hidden = false;
      if (scrim) scrim.hidden = false;
      void menu.offsetWidth;
    }
    menu.classList.toggle('is-open', open);
    if (scrim) scrim.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) {
      setTimeout(function () {
        if (!menu.classList.contains('is-open')) {
          menu.hidden = true;
          if (scrim) scrim.hidden = true;
        }
      }, 320);
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cx-menu-open]')) { e.preventDefault(); setMenu(true); return; }
    if (e.target.closest('[data-cx-menu-close]') || e.target.closest('[data-cx-scrim]')) {
      e.preventDefault(); setMenu(false); return;
    }
    var t = e.target.closest('[data-cx-menu-toggle]');
    if (t) {
      e.preventDefault();
      t.parentElement.classList.toggle('is-open');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) setMenu(false);
  });

  /* ---------------- product card swatches ---------------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-cx-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-cx-card]');
    if (!card) return;

    var main = card.querySelector('[data-cx-cardimg]');
    var img = sw.getAttribute('data-img');
    if (main && img) {
      main.src = img;
      main.srcset = '';
      // the second photo belongs to the previous colour, so retire the hover swap
      var hover = card.querySelector('[data-cx-cardhover]');
      if (hover) hover.style.display = 'none';
    }
    // send the card's links to the chosen variant
    var url = sw.getAttribute('data-url');
    if (url) {
      card.querySelectorAll('a[href]').forEach(function (a) { a.href = url; });
    }
    card.querySelectorAll('[data-cx-swatch]').forEach(function (b) {
      b.classList.toggle('is-active', b === sw);
    });
  });

  /* ---------------- add-to-cart feedback ----------------
     The add itself is handled by mt-core.js and works, but nothing on screen
     changed: no drawer, and the header count only moved on reload, so the
     button read as dead. Refresh the count and confirm on the button. */
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cx-cartcount]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart.item_count;
      })
      .catch(function () { return null; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mt-atc], .cx-cmp__add');
    if (!btn || btn.dataset.cxBusy) return;
    var label = btn.textContent;
    btn.dataset.cxBusy = '1';
    // mt-core.js posts to /cart/add.js; give it a moment, then reflect the result
    setTimeout(function () {
      refreshCartCount().then(function (n) {
        btn.textContent = n === null ? label : 'ADDED ✓';
        setTimeout(function () {
          btn.textContent = label;
          delete btn.dataset.cxBusy;
        }, 1600);
      });
    }, 700);
  });

  refreshCartCount();

  /* ---------------- layout measurements ----------------
     Two values that depend on rendered height and so cannot be hard-coded:
       --cx-header-h  the hero is pulled up by exactly the header's height
*/
  function measure() {
    var header = document.querySelector('.cx-header');
    if (header) {
      document.documentElement.style.setProperty(
        '--cx-header-h', Math.round(header.getBoundingClientRect().height) + 'px');
    }
  }

  measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);
  // accordions change the column height, which changes where it should pin
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cx-acc .acc__head')) setTimeout(measure, 60);
  });
})();
